module.exports = __webpack_public_path__ + "static/com_aurora-41c73c7dbacd93e84d036ee946ed4e54.png";